import { useState, useMemo } from 'react';

import { CommentPreview } from '@gogame/components';

import CommentWithMarkForm from './CommentWithMarkForm';
import { ID, TEXT, MARK } from './constants';

export const DATA_CY = 'review';

const Review = ({
  id,
  mark,
  author = '',
  date = '',
  message = '',
  label,
  onComment,
  onDelete,
  withActions,
  autoFocus,
}) => {
  const [editing, setEditing] = useState(false);

  const handleComment = async (...args) => {
    await onComment(...args);
    setEditing(false);
  };

  const initialValues = useMemo(() => {
    return {
      [ID]: id,
      [TEXT]: message,
      [MARK]: mark,
    };
  }, [id, message, mark]);

  if (editing) {
    return (
      <CommentWithMarkForm
        autoFocus={autoFocus}
        label={label}
        initialValue={initialValues}
        onChange={handleComment}
        onCancel={() => setEditing(false)}
      />
    );
  }

  return (
    <CommentPreview
      dataCy={DATA_CY}
      mark={mark}
      author={author}
      date={date}
      message={message}
      withActions={withActions}
      onEdit={() => setEditing(true)}
      onDelete={
        onDelete
          ? onDelete
          : async () => {
              await onComment({ target: { value: '' } }, '');
            }
      }
    />
  );
};
export default Review;
